
export function LoadingScreen() {
  return (
    <div className="loading">
      <div className="loading__spinner" aria-hidden="true" />
      <p className="loading__text">Loading module…</p>
    </div>
  );
}
